module.exports = __webpack_public_path__ + "static/itunes-pod-8a2c2e62e005221a38a70e77b8976ec1.png";